module.exports = __webpack_public_path__ + "img/17.bce99f59.jpg";